(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-support"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shady-custom-cart')) {
    customElements.define(
      'shady-custom-cart',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          if (this.events) return;

          this.events = new AbortController();
          const options = { signal: this.events.signal };

          this.form = this.querySelector('[data-cart-form]');
          this.dialog = this.querySelector('[data-support-dialog]');
          this.checkout = this.querySelector('[data-checkout]');
          this.openButton = this.querySelector('[data-open-support]');
          this.storageKey = 'shady-support-' + this.dataset.sectionId;
          this.dirty = false;
          this.busy = false;
          this.bypass = false;
          this.uncertain = false;

          this.setupVideo(options);

          if (!this.form) return;

          this.form.addEventListener('input', () => {
            this.dirty = true;
            this.checkout.textContent = 'Update cart to continue';
            this.querySelector('[data-change-message]').textContent =
              'Update your cart to save your changes and refresh the total.';
            if (this.openButton) this.openButton.disabled = true;
          }, options);

          const canShowDialog =
            this.dialog && typeof this.dialog.showModal === 'function';

          this.form.addEventListener('submit', (event) => {
            if (this.uncertain) {
              event.preventDefault();
              window.location.reload();
              return;
            }

            const isCheckout =
              event.submitter && event.submitter.name === 'checkout';

            if (!isCheckout) return;

            if (this.dirty) {
              event.preventDefault();
              this.form.requestSubmit(this.querySelector('[data-update]'));
              return;
            }

            if (canShowDialog && !this.bypass) {
              event.preventDefault();
              this.dialog.showModal();
            }
          }, options);

          if (!canShowDialog) return;

          this.openButton.hidden = false;
          this.openButton.addEventListener('click', () => {
            this.dialog.showModal();
          }, options);

          this.dialog.querySelectorAll('[data-close-support]').forEach(
            (button) => {
              button.addEventListener('click', () => {
                if (!this.busy) this.dialog.close();
              }, options);
            }
          );

          this.dialog.addEventListener('cancel', (event) => {
            if (this.busy) event.preventDefault();
          }, options);

          this.dialog.querySelector('[data-proceed]').addEventListener(
            'click',
            () => {
              if (this.busy) return;

              if (this.uncertain) {
                window.location.reload();
                return;
              }

              this.dialog.close();
              this.bypass = true;
              this.form.requestSubmit(this.checkout);
              this.bypass = false;
            },
            options
          );

          this.dialog.querySelectorAll('[data-addon-form]').forEach(
            (form) => {
              form.addEventListener('submit', (event) => {
                event.preventDefault();
                this.addExtra(form);
              }, options);
            }
          );

          try {
            const saved = Number(sessionStorage.getItem(this.storageKey));
            sessionStorage.removeItem(this.storageKey);

            if (saved && Date.now() - saved < 120000) {
              this.dialog.showModal();
              this.querySelector('[data-status]').textContent =
                'Item added. Your cart and total have been updated.';
            }
          } catch (_) {
            // The cart still works when session storage is unavailable.
          }
        }

        setupVideo(options) {
          this.video = this.querySelector('.sc-background-video');
          const button = this.querySelector('[data-video-toggle]');
          if (!this.video || !button) return;

          this.video.muted = true;
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          button.hidden = false;

          const updateLabel = () => {
            button.textContent = this.video.paused
              ? 'Play background'
              : 'Pause background';
          };

          button.addEventListener('click', () => {
            if (this.video.paused) {
              this.video.play().catch(updateLabel);
            } else {
              this.video.pause();
            }
          }, options);

          this.video.addEventListener('play', updateLabel, options);
          this.video.addEventListener('pause', updateLabel, options);

          this.motionChange = () => {
            if (this.motion.matches) this.video.pause();
          };

          this.motion.addEventListener('change', this.motionChange);

          updateLabel();

          if (!this.motion.matches) {
            this.video.play().catch(updateLabel);
          }
        }

        setBusy(value) {
          this.busy = value;
          this.dialog.setAttribute('aria-busy', String(value));

          this.dialog.querySelectorAll('button, select').forEach(
            (control) => {
              control.disabled = value;
            }
          );
        }

        async addExtra(form) {
          if (this.busy || this.uncertain || !form.reportValidity()) return;

          const status = this.querySelector('[data-status]');
          const variantId = form.elements.id.value;

          this.setBusy(true);
          status.textContent = 'Adding to your cart…';

          let confirmedRejection = false;

          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
              })
            });

            const result = await response.json();

            if (!response.ok) {
              confirmedRejection =
                response.status >= 400 && response.status < 500;

              throw new Error(
                typeof result.description === 'string'
                  ? result.description
                  : 'This item could not be added.'
              );
            }

            status.textContent = 'Added. Refreshing your cart…';

            try {
              sessionStorage.setItem(this.storageKey, String(Date.now()));
            } catch (_) {
              // Reloading still refreshes the cart when storage is blocked.
            }

            window.location.reload();
          } catch (error) {
            this.setBusy(false);

            if (confirmedRejection) {
              status.textContent = error.message;
            } else {
              this.uncertain = true;
              status.textContent =
                'We could not confirm the cart update. Refresh your cart before trying again to avoid adding the item twice.';

              this.dialog.querySelectorAll('[data-addon-form] button').forEach(
                (button) => { button.disabled = true; }
              );

              this.dialog.querySelector('[data-proceed]').textContent =
                'Refresh cart';
              this.checkout.textContent = 'Refresh cart';
            }
          }
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.events?.abort();
          this.events = null;

          if (this.dialog?.open) this.dialog.close();
          if (this.video) this.video.pause();

          if (this.motion && this.motionChange) {
            this.motion.removeEventListener('change', this.motionChange);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullwidth-video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fullwidth-video-banner')) {
    customElements.define(
      'fullwidth-video-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.mount());
        }

        mount() {
          if (this.abort) return;

          this.abort = new AbortController();
          const options = { signal: this.abort.signal };

          // Fill the actual viewport, excluding the scrollbar.
          const resize = () => {
            this.style.setProperty(
              '--fvb-width',
              `${document.documentElement.clientWidth}px`
            );

            this.style.setProperty('--fvb-offset', '0px');

            this.style.setProperty(
              '--fvb-offset',
              `${-this.getBoundingClientRect().left}px`
            );
          };

          resize();
          window.addEventListener('resize', resize, options);

          const template = this.querySelector('template');
          const toggle = this.querySelector('[data-video-toggle]');

          if (!template || !toggle) return;

          const motion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

          const video = template.content
            .querySelector('video')
            .cloneNode(true);

          this.video = video;

          video.muted = true;
          video.defaultMuted = true;
          video.autoplay = !motion.matches;

          const sync = () => {
            toggle.textContent = video.paused
              ? 'Play video'
              : 'Pause video';
          };

          const play = () => {
            const attempt = video.play();

            // Browser policy may prevent autoplay.
            // Leave the manual play control available.
            if (attempt) attempt.catch(sync);
          };

          video.addEventListener('play', sync, options);
          video.addEventListener('pause', sync, options);

          video.addEventListener(
            'error',
            () => {
              video.hidden = true;
              toggle.hidden = true;
            },
            options
          );

          this.querySelector('.fvb__media').append(video);

          toggle.hidden = false;
          sync();

          toggle.addEventListener(
            'click',
            () => {
              if (video.paused) {
                play();
              } else {
                video.pause();
              }
            },
            options
          );

          motion.addEventListener(
            'change',
            (event) => {
              if (event.matches) video.pause();
            },
            options
          );

          if (!motion.matches) play();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);

          this.abort?.abort();
          this.video?.pause();
          this.video?.remove();

          this.video = null;
          this.abort = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-logo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-logo-bar')) {
    customElements.define('scrolling-logo-bar', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('.smb__track');
        this.seed = this.querySelector('[data-seed]');
        this.viewport = this.querySelector('.smb__viewport');
        this.button = this.querySelector('.smb__toggle');
        if (!this.track || !this.seed || !this.button) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.hovered = false;
        this.editorPaused = false;
        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.rebuild());
        };

        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updateState();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && this.dataset.pauseHover === 'true') {
            this.hovered = true;
            this.updateState();
          }
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.updateState();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          this.editorPaused = true;
          if (this.animation && this.seed.contains(event.target)) {
            const offset = event.target.getBoundingClientRect().left - this.seed.getBoundingClientRect().left;
            this.animation.currentTime = Math.max(0, offset) / this.speed * 1000;
          }
          this.updateState();
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editorPaused = false;
          this.updateState();
        }, options);
        window.addEventListener('resize', schedule, options);
        this.motion.addEventListener('change', schedule, options);
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this);
        this.observer.observe(this.seed);
        this.rebuild();
      }
      removeCopies() {
        this.track.querySelectorAll('[data-copy]').forEach((node) => node.remove());
      }
      rebuild() {
        if (!this.isConnected) return;
        if (this.dataset.fullWidth === 'true') {
          // Match the viewport without adding scrollbar-width overflow.
          this.style.setProperty('--smb-width', `${document.documentElement.clientWidth}px`);
          this.style.setProperty('--smb-offset', '0px');
          this.style.setProperty('--smb-offset', `${-this.getBoundingClientRect().left}px`);
        }

        const reduced = this.motion.matches;
        this.classList.toggle('is-ready', !reduced);
        this.button.hidden = reduced;
        if (reduced) {
          this.animation?.cancel();
          this.animation = null;
          this.signature = '';
          this.removeCopies();
          this.updateState();
          return;
        }
        const distance = this.seed.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        if (!distance || !viewportWidth) return;
        this.speed = Math.max(1, Number(this.dataset.speed) || 50);
        const signature = `${distance}:${viewportWidth}:${this.speed}`;
        if (signature !== this.signature) {
          this.removeCopies();
          // Fill wide screens even when only a small logo is used.
          const count = Math.ceil(viewportWidth / distance) + 1;
          for (let i = 1; i < count; i++) {
            const copy = this.seed.cloneNode(true);
            copy.removeAttribute('data-seed');
            copy.setAttribute('data-copy', '');
            copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach((node) => {
              node.removeAttribute('id');
              node.removeAttribute('data-shopify-editor-block');
            });
            this.track.append(copy);
          }
          // Keep repeated wheel images at the same rotation angle.
          const wheels = [...this.track.querySelectorAll('.smb__wheel')];
          const wheelTime = wheels[0]?.getAnimations()[0]?.currentTime || 0;
          wheels.forEach((wheel) => wheel.getAnimations().forEach((animation) => {
            animation.currentTime = wheelTime;
          }));
          this.animation?.cancel();
          this.animation = this.track.animate([
            { transform: 'translateX(0px)' },
            { transform: `translateX(-${distance}px)` }
          ], { duration: distance / this.speed * 1000, iterations: Infinity, easing: 'linear' });
          this.signature = signature;
        }
        this.updateState();
      }
      updateState() {
        const paused = this.userPaused || this.hovered || this.editorPaused || this.motion.matches;
        if (this.animation) paused ? this.animation.pause() : this.animation.play();
        this.style.setProperty('--smb-play-state', paused ? 'paused' : 'running');
        const label = this.userPaused ? 'Resume scrolling bar' : 'Pause scrolling bar';
        this.button.setAttribute('aria-label', label);
        this.button.title = label;
        this.button.querySelector('[data-pause-icon]').toggleAttribute('hidden', !!this.userPaused);
        this.button.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.userPaused);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.animation?.cancel();
        this.controller = null;
        this.animation = null;
        this.signature = '';
        this.classList.remove('is-ready');
        this.style.setProperty('--smb-play-state', 'paused');
        if (this.track) this.removeCopies();
        if (this.button) this.button.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shady-shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shady-brand-carousel')) {
    customElements.define('shady-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.ssb__track');
        this.pages = Array.from(this.querySelectorAll('.ssb__page'));
        this.previous = this.querySelector('.ssb__previous');
        this.next = this.querySelector('.ssb__next');
        this.status = this.querySelector('.ssb__status');
        this.index = 0;
        this.previous.addEventListener('click', () => this.go(this.index - 1), options);
        this.next.addEventListener('click', () => this.go(this.index + 1), options);
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.index = Math.max(0, Math.min(this.pages.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
            this.update();
          }, 140);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const page = event.target.closest('.ssb__page');
          const index = this.pages.indexOf(page);
          if (index >= 0) this.go(index, false);
        }, options);
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        this.update();
      }
      go(index, animate = true) {
        this.index = Math.max(0, Math.min(this.pages.length - 1, index));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: animate && !reduce ? 'smooth' : 'instant' });
        this.update();
      }
      update() {
        this.previous.disabled = this.index === 0 || this.pages.length < 2;
        this.next.disabled = this.index >= this.pages.length - 1;
        this.pages.forEach((page, index) => { page.inert = index !== this.index; });
        this.status.textContent = this.pages.length > 1 ? `${this.status.dataset.label} ${this.index + 1} / ${this.pages.length}` : '';
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shady-product-feature')) {
    customElements.define(
      'shady-product-feature',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          if (this.controller) return;

          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          if (this.slides.length < 2) return;

          this.controller = new AbortController();
          const options = { signal: this.controller.signal };

          this.index = 0;
          this.delay = Math.max(2000, Number(this.dataset.speed) || 4000);
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.paused = this.motion.matches;
          this.toggle = this.querySelector('[data-toggle]');
          this.counter = this.querySelector('[data-current]');

          this.querySelector('.spf-controls').hidden = false;

          this.querySelector('[data-prev]').addEventListener(
            'click',
            () => {
              this.show(this.index - 1);
              this.schedule();
            },
            options
          );

          this.querySelector('[data-next]').addEventListener(
            'click',
            () => {
              this.show(this.index + 1);
              this.schedule();
            },
            options
          );

          this.toggle.addEventListener(
            'click',
            () => {
              this.paused = !this.paused;
              this.updateButton();
              this.schedule();
            },
            options
          );

          document.addEventListener(
            'visibilitychange',
            () => this.schedule(),
            options
          );

          this.onMotionChange = () => {
            this.paused = this.motion.matches;
            this.updateButton();
            this.schedule();
          };

          this.motion.addEventListener('change', this.onMotionChange);

          this.show(0);
          this.updateButton();
          this.schedule();
        }

        show(nextIndex) {
          this.index =
            (nextIndex + this.slides.length) % this.slides.length;

          this.slides.forEach((slide, index) => {
            const active = index === this.index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
          });

          this.counter.textContent = String(this.index + 1);
        }

        updateButton() {
          this.toggle.textContent = this.paused ? 'Play' : 'Pause';
          this.toggle.setAttribute(
            'aria-label',
            this.paused
              ? 'Play product slideshow'
              : 'Pause product slideshow'
          );
        }

        schedule() {
          clearTimeout(this.timer);

          if (this.paused || document.hidden || !this.isConnected) return;

          this.timer = setTimeout(() => {
            this.show(this.index + 1);
            this.schedule();
          }, this.delay);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          clearTimeout(this.timer);
          this.controller?.abort();
          this.controller = null;

          if (this.motion && this.onMotionChange) {
            this.motion.removeEventListener('change', this.onMotionChange);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vehicle-contact-page')) {
    customElements.define('vehicle-contact-page', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('[data-form-status]')?.focus();

        const template = this.querySelector('[data-video-template]');
        const toggle = this.querySelector('.vcp__video-toggle');
        if (!template || !toggle || Number(this.dataset.videoOpacity) <= 0) return;

        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const sync = () => {
          toggle.textContent = this.video && !this.video.paused
            ? 'Pause background video' : 'Play background video';
        };
        const play = () => {
          if (!this.video) {
            this.video = template.content.querySelector('video').cloneNode(true);
            this.video.muted = true;
            this.video.defaultMuted = true;
            this.video.addEventListener('play', sync, options);
            this.video.addEventListener('pause', sync, options);
            this.video.addEventListener('error', () => {
              this.video.hidden = true;
              toggle.hidden = true;
            }, options);
            this.querySelector('.vcp__media').append(this.video);
          }
          // A blocked autoplay request leaves a manual play button available.
          const attempt = this.video.play();
          if (attempt) attempt.catch(sync);
        };
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          if (this.video && !this.video.paused) this.video.pause();
          else play();
        }, options);
        motion.addEventListener('change', (event) => {
          if (event.matches) this.video?.pause();
        }, options);
        if (!motion.matches) play();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.video?.pause();
        this.video?.remove();
        this.video = null;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-youtube-feature')) {
    customElements.define('custom-youtube-feature', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        // Some videos do not have a high-resolution YouTube thumbnail.
        const image = this.querySelector('[data-youtube-thumbnail]');
        if (image) {
          const fallback = () => {
            if (image.dataset.fallback) {
              const url = image.dataset.fallback;
              delete image.dataset.fallback;
              image.src = url;
            } else {
              image.hidden = true;
            }
          };
          image.addEventListener('error', fallback, options);
          image.addEventListener('load', () => {
            if (image.naturalWidth < 200) fallback();
          }, options);
          if (image.complete && image.naturalWidth < 200) fallback();
        }

        const trigger = this.querySelector('[data-inline-play]');
        const template = this.querySelector('[data-player-template]');
        if (!trigger || !template) return;

        trigger.addEventListener('click', () => {
          if (this.querySelector('.ytf__media iframe')) return;
          const player = template.content.firstElementChild.cloneNode(true);
          trigger.hidden = true;
          this.querySelector('.ytf__media').append(player);
          player.focus();
        }, options);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.controller = null;
        this.querySelector('.ytf__media iframe')?.remove();
        const trigger = this.querySelector('[data-inline-play]');
        if (trigger) trigger.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
